import { NAME } from '../constants';

export const UPDATE_MEDIA_TIME = `${NAME}/updateMediaTime`;
export const UPDATE_IS_PLAYING = `${NAME}/updateIsPlaying`;
export const RESET_MEDIA = `${NAME}/resetMedia`;
export const SEND_TIME_CHANGE_REQUEST = `${NAME}/sendTimeChangeRequest`;
export const CLEAR_TIME_CHANGE_REQUEST = `${NAME}/clearTimeChangeRequest`;
